import Vue from 'vue'
import VueRouter from 'vue-router'
import { getAuth } from "../firebase";
Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'home',
    component: () => import('../views/HomeView.vue')
  },
  {
    path: '/seeds-software',
    name: 'seeds-software',
    component: () => import('../components/Seeds Software/Dashboard.vue'),
    meta: { requireAuth: true }
  },
  {
    path: '/seeds-drop',
    name: 'seeds-drop',
    component: () => import('../components/Seeds Software/SeedsDrop.vue'),
    meta: { requireAuth: true }
  },
  {
    path: '/plants-on-system',
    name: 'plants-on-system',
    component: () => import('../components/Seeds Software/PlantsOnSystem.vue'),
    meta: { requireAuth: true }
  },
  {
    path: '/harvest-packaging',
    name: 'harvest-packaging',
    component: () => import('../components/Seeds Software/HarvestPackaging.vue'),
    meta: { requireAuth: true }
  },
  {
    path: '/leaving-the-farm',
    name: 'leaving-the-farm',
    component: () => import('../components/Seeds Software/LeavingTheFarm.vue'),
    meta: { requireAuth: true }
  },
  {
    path: '/driver',
    name: 'driver',
    component: () => import('../components/Seeds Software/Driver.vue'),
    meta: { requireAuth: true }
  },
  {
    path: '/farms-farm-seeds',
    name: 'farms-farm-seeds',
    component: () => import('../components/Seeds Software/FarmSelected.vue'),
    meta: { requireAuth: true }
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

router.beforeEach((to, from, next) => {
  const ruteProtect = to.matched.some(record => record.meta.requireAuth);
  const user = getAuth().currentUser;

  if (ruteProtect === true && user === null) {
    next({name: 'home'})
  } else {
    next()
  }
})

export default router
